export const featureFlags = {
  unifiedLeads: {
    enabled: true, // Enabled for deduplication
    source: 'unified', // Use unified API for deduplicated view
  },
  myPay: {
    enabled: true, // My Pay page (/my-pay) + nav entries — nothing user-visible until enabled
    source: 'comp-statement-v1', // Backed by the versioned comp-statement contract
  },
};
